<script>
    import {logout,getResource } from '@src/service.js'
    import {language} from '@src/languages.js'
    import Link from '@src/router/Link.svelte'
    import Progress from '@src/components/Progress.svelte'
    import routerManager from '@src/router/router'

    const router = routerManager.getRouter('default')
    let resp = getResource('profile')
    function signout(){
        
        logout()
        // $$props.router.navigate('home')
        router.navigate('home')
    }

    function handleChangePass(){
        console.log('changing password')

    }
</script>
<style>
    .list li {
            border-bottom: solid thin #dfdfdf;
    }
    .list li.sperator {

        border-bottom: solid thin #888;
    }
</style>
<div class="w-full h-full flex flex-col align-start p-4">
    {#await $resp}
        <Progress/>
    {:then user} 
        <div class="grid grid-cols-4 gap-4 px-2 font-bold">
            <span class="col-span-2">{$language.label_username } :</span><span >{user.username}</span>
            <span class="col-span-2">{$language.label_fullname } :</span><span>{user.username}</span>
            <span class="col-span-2">{$language.label_email } :</span><span>{user.email || '--'}</span>
            
        </div>
        <hr>        
        <ul class="list px-2 mt-8">        
            {#if !(user.username == 'guest')}
            <li class="text-green-800 mb-6">                 
                <Link to={'change_pass'} {...$$props} >
                    <svg class="inline-block mx-2 " viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" width="21" height="21"><path d="M11 11h-1v-1h1v1zm-3 0h1v-1H8v1zm5 0h-1v-1h1v1z" fill="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M3 6V3.5a3.5 3.5 0 117 0V6h1.5A1.5 1.5 0 0113 7.5v.55a2.5 2.5 0 010 4.9v.55a1.5 1.5 0 01-1.5 1.5h-10A1.5 1.5 0 010 13.5v-6A1.5 1.5 0 011.5 6H3zm1-2.5a2.5 2.5 0 015 0V6H4V3.5zM8.5 9a1.5 1.5 0 100 3h4a1.5 1.5 0 000-3h-4z" fill="currentColor"></path></svg>
                    <span class="inline-block align-middle ">{$language.btn_change_pass}</span>        
                </Link>
            </li>
            <li class="text-green-800">                 
                <Link to={'change_email'} {...$$props} >   
                    <svg class="inline-block mx-2 " viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg" width="22" height="22"><path d="M.5 2.5A1.5 1.5 0 012 1h12a1.5 1.5 0 011.5 1.5v1.208L8 7.926.5 3.708V2.5z" fill="currentColor"></path><path d="M.5 4.855V12.5A1.5 1.5 0 002 14h12a1.5 1.5 0 001.5-1.5V4.855L8 9.074.5 4.854z" fill="currentColor"></path></svg>                 
                    <span class="inline-block align-middle ">{$language.btn_change_email}</span>        
                </Link>
            </li>
            <li class="sperator my-4">
                <div class="my-20"></div>
            </li>
            {/if}
            <li  class="" on:click={signout}>
                <svg class="inline-block mx-2" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" width="21" height="21"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 0v9H7V0h1zm4.387 1.792l.358.35A7.468 7.468 0 0115 7.494C15 11.635 11.644 15 7.5 15 3.358 15 0 11.635 0 7.495a7.46 7.46 0 012.269-5.354l.357-.35.7.716-.359.35A6.463 6.463 0 001 7.494 6.506 6.506 0 007.5 14c3.59 0 6.5-2.917 6.5-6.505a6.464 6.464 0 00-1.955-4.639l-.357-.35.7-.714z" fill="currentColor"></path></svg>
                <span>{$language.btn_logout}</span>
            </li>
            
        </ul>
    {:catch error}     
            <h1>{error}</h1>      
        
    {/await}
</div>